export default class CityModel {
    codigo: string | null;
    nomeMunicipio: string | null;
    codigoUf: number | null;
    uf: string | null;

    constructor(
        codigo: string | null,
        nomeMunicipio: string | null,
        codigoUf: number | null,
        uf: string | null
    ) {
        this.codigo = codigo;
        this.nomeMunicipio = nomeMunicipio;
        this.codigoUf = codigoUf;
        this.uf = uf;
    }

    static fromApiResponse(data: any): CityModel {
        return new CityModel(
            data.codigo || null,
            data.nome_municipio || null,
            data.codigo_uf || null,
            data.uf || null
        );
    }

    static fromApiResponseArray(dataArray: any[]): CityModel[] {
        return dataArray.map(data => CityModel.fromApiResponse(data));
    }
}